import I18n from 'I18n';
import { getUserTextKey } from '../../utils/userUtils';
import { ReportLastViewed } from './info/ReportLastViewed';
import { ReportLastUpdated } from './info/ReportLastUpdated';
import { ReportBusinessUnitName } from './info/ReportBusinessUnitName';
import { List } from 'foundations-components/transitional/components/List';
// @ts-expect-error Untyped import
import { isStandaloneReport } from 'reporting-action-components/lib/report-logic';
// @ts-expect-error Untyped import
import { getReportOwnerUser } from 'reporting-action-components/data/schemas/reportSchema';
// @ts-expect-error Untyped import
import { getReportDashboardInfo } from 'reporting-action-components/data/schemas/reportSchema';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReportsGridCardInfo = ({
  report
}) => {
  const owner = getReportOwnerUser(report);
  const ownerTextKey = getUserTextKey(owner);
  const dashboards = getReportDashboardInfo(report) || [];
  const dashboardCount = dashboards.length;
  const accessClassification = report.get('accessClassification');
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.reportOwnerName",
      options: {
        ownerFullName: ownerTextKey === 'fullName' ? owner.get('fullName') : I18n.text(ownerTextKey)
      }
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.dashboardCount",
      options: {
        count: dashboardCount
      }
    }), /*#__PURE__*/_jsx(ReportBusinessUnitName, {
      report: report
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.accessClassification",
      options: {
        assigned: isStandaloneReport(report) ? I18n.text(`reports.subHeader.assigned.options.${accessClassification}`) : '--'
      }
    }), /*#__PURE__*/_jsx(ReportLastViewed, {
      report: report
    }), /*#__PURE__*/_jsx(ReportLastUpdated, {
      report: report
    })]
  });
};